// extracted by mini-css-extract-plugin
export default {"restaurantCard":"restaurantCard_restaurantCard__AkgfL","containerImg":"restaurantCard_containerImg__X95K4","imgRestaurant":"restaurantCard_imgRestaurant__7oQSf"};